import { CallToAction } from "../CTA/CallToActionButton";

export const VideoBanner = ({ headerText, subtitle, content, imageComponent, formattedSectionStyles, ctas }) => {
	return (
		<article className="flex flex-col gap-2 sm:gap-4">
			<div className="flex flex-col md:flex-row md:items-center md:gap-12">
				<div className="w-full md:w-1/2 mb-6 md:mb-0">
					{subtitle && (
						<span className={`text-is2_md ${formattedSectionStyles.textColor}`}>
							{subtitle}
						</span>
					)}
					{headerText && (
						<h2 className={`${formattedSectionStyles.textColor} text-center md:text-left`}>
							{headerText}
						</h2>
					)}
					{content && (
						<div className={`${formattedSectionStyles.textColor} text-sm mt-4 m-auto md:m-0 text-center md:text-left`}>
							{content}
						</div>
					)}
					{ctas?.length ? (
						<div className="flex flex-row flex-wrap gap-4 mt-8 justify-center md:justify-start pb-[64px]">
							{ctas.map((cta, index) => (
								<CallToAction
									key={`${cta.title}-${index}`}
									title={cta.buttonText || cta.title}
									{...cta}
								/>
							))}
						</div>
					) : null}
				</div>
				{imageComponent}
			</div>
		</article>
	);
};
